function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.938 13.594V1.406c0-.259.21-.468.468-.468h7.032v1.875c0 .517.42.937.937.937h1.875v1.406h.938V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h3.282v-.938H1.405a.469.469 0 01-.468-.468z",
  fill: "#0785FE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.625 7.5H3.75a.469.469 0 00-.469.469v3.75c0 .259.21.469.469.469h1.875c.518 0 .938-.42.938-.938V8.438a.938.938 0 00-.938-.938zm0 3.75H4.219V8.438h1.406v2.812zM8.906 7.5c-1.035 0-1.875.84-1.875 1.875v.938a1.875 1.875 0 003.75 0v-.938c0-1.035-.84-1.875-1.875-1.875zm.938 2.813a.938.938 0 01-1.875 0v-.938a.938.938 0 011.875 0v.938zM13.125 11.25a.938.938 0 01-.938-.937v-.938a.937.937 0 111.876 0H15a1.875 1.875 0 00-3.75 0v.938a1.875 1.875 0 003.75 0h-.938c0 .518-.42.937-.937.937z",
  fill: "#0785FE"
});

function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgDoc;